<h3>GARE CRITTOGRAFICHE</h3>
<p> Tra le attività della De Cifris troviamo l'organizzazione di gare e sfide
	a tema crittografico. In particolare organizziamo hackathon e
	<a routerLink="/attivita/cryptowars">cryptowars</a>.
</p>
<hr>
<p>Hackathon:</p>
<ul>
	<li>
		<b><a [routerLink]="['/ixh24']">IXH24</a></b>
		<p>
			Il nostro primo hackathon nazionale, nell'eterna Roma. Dal 21 al 23 Novembre 2024. Organizzato
			congiuntamente con: <i>Università di Roma Tre</i>, <i>Ripple Commons</i>.
		</p>
	</li>
	<li>
		<b>Hackathon 2019</b>
		<p>
			L'evento si è svolto il giorno 26 settembre 2019, simultaneamente in due sedi:
		</p>
		<ul>
			<li>Department of Computer Science UniMi - Aula Magna A. Bertoni, via Celoria 18, Milano.</li>
			<li>Department of Mathematics UniTn e FBK - Sala Consiglio FBK, via Sommarive 18, Povo, Trento.</li>
		</ul>
		<br>
		<p>
			In tale occasione sono stati presentati due progetti da realizzare, all'interno del
			tema generale dell'Hackathon: Food, Health & Sustainability, con inclusi aspetti crittografici.
		</p>
	</li>
</ul>
<p>Cryptowars:</p>
<ul>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2021']">Cryptowars 2021</a></b>
		<p>
			L'evento si è svolto dal 25 al 31 Ottobre 2021, e ha visto iscritti alla
			competizione 6 team provenienti da: Milano, Cagliari, Torino e Padova.
		</p>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2020']">Cryptowars 2020</a></b>
		<p>
			L'evento si è svolto dal 25 al 31 Ottobre 2020, e ha visto iscritti alla
			competizione 17 team provenienti da: Padova, Perugia, Torino, Milano,
			Cagliari, Trento, Ancona, Bologna, Venezia, Roma e Pisa.
		</p>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2019']">Cryptowars 2019</a></b>
		<p>
			L'evento si è svolto dal 21 al 27 Ottobre 2019, e ha visto iscritti alla
			competizione 13 team, più un gruppo che ha partecipato esternamente alla gara.
		</p>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2018']">Cryptowars 2018</a></b>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2016']">Cryptowars 2016</a></b>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2015']">Cryptowars 2015</a></b>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2014']">Cryptowars 2014</a></b>
	</li>
	<li>
		<b><a [routerLink]="['/attivita/cryptowars/2011']">Cryptowars 2011</a></b>
	</li>
</ul>